export const sortOptions = [
  {
    label: 'Сначала новые',
    value: undefined,
  },
  {
    label: 'Сначала старые',
    value: 'asc.add',
  },
  {
    label: 'Сначала популярные',
    value: 'desc.pop',
  },
  {
    label: 'Сначала непопулярные',
    value: 'asc.pop',
  },
]
